import { Injectable } from '@angular/core';
import * as RouteConstants from '../constants/route.constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RegionSelectOptionModel } from '../models/region-select-option.model';
import { RegionViewDataModel } from '../models/region-view-data.model';
import { FilterRequestModel } from '../models/filter-request.model';
import { MecsFilterSelectOptions } from '../models/mecs-models/mecs-filter-select-options.model';
import { MecsRegionFilterSelectOptions } from '../models/mecs-models/mecs-region-filter-select-options.model';
import { FilterRequestMecsModel } from '../models/mecs-models/filter-request-mecs.model';
import { MecsRegionalSolutionsLaunchPhaseModel } from '../models/mecs-models/mecs-regional-solutions-laynch-phase.model';

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  private routeConstants = RouteConstants;

  constructor(private httpClient: HttpClient) { }

  getRegionOptions(): Observable<RegionSelectOptionModel[]>{ 
    return this.httpClient.get<RegionSelectOptionModel[]>(this.routeConstants.GET_REGION_OPTIONS_ROUTE);
  }

  getMecsRegionOptions(): Observable<RegionSelectOptionModel[]>{ 
    return this.httpClient.get<RegionSelectOptionModel[]>(this.routeConstants.GET_MECS_REGION_OPTIONS_ROUTE);
  }

  getRegionData(regionId: number, filterRequest: FilterRequestModel): Observable<RegionViewDataModel>{
    let queryParams = new HttpParams();
    queryParams = queryParams.append('regionId', regionId);
    
    return this.httpClient.post<RegionViewDataModel>(this.routeConstants.GET_REGION_DATA_ROUTE, filterRequest, {params: queryParams});
  }

  getMecsFilterOptions(): Observable<MecsFilterSelectOptions>{
    return this.httpClient.get<MecsFilterSelectOptions>(this.routeConstants.GET_MECS_FILTER_OPTIONS_ROUTE);
  }
  
  getMecsRegionFilterOptions(regionId: number): Observable<MecsRegionFilterSelectOptions>{
    let queryParams = new HttpParams();
    queryParams = queryParams.append('regionId', regionId);

    return this.httpClient.get<MecsRegionFilterSelectOptions>(this.routeConstants.GET_MECS_REGION_FILTER_OPTIONS_ROUTE, {params: queryParams});
  }

  getMecsRegionalSolutionLaunchPhase(filterRequest: FilterRequestMecsModel): Observable<MecsRegionalSolutionsLaunchPhaseModel[]>{
    return this.httpClient.post<MecsRegionalSolutionsLaunchPhaseModel[]>(this.routeConstants.GET_MECS_REGIONAL_SOLUTION_LAUNCH_PHASE, filterRequest);
  }
}
